/* v8 ignore start */
import {JsonModel} from "@/lib/core/jsonModel";
import {LottieKeyFrameModel} from "@/lib/lottie/animatedProperties/lottieKeyframeModel";
import {TIntBoolean} from "@/lib/lottie/helpers/intBoolean";

export class LottieAnimatedPropertyModel<S, T extends LottieAnimatedPropertyModel.TJson<S>> extends JsonModel<T> {}

export namespace LottieAnimatedPropertyModel {
  export type TJson<T> = IStaticAnimatedPropertyJson<T> | IKeyframeAnimatedPropertyJson;

  export interface IBaseJson<T> {
    /**
     * Property Index
     */
    ix?: number;

    /**
     * Whether the property is animated
     * @default 0
     */
    a?: TIntBoolean;

    /**
     * Expression
     */
    x?: string;

    /**
     * Slot ID
     * One of the ID in the file's slots
     */
    sid?: string;

    /**
     * The value of the property.
     * If `a` is 0 or undefined, this is a static value.
     * If `a` is 1, this is an array of keyframes.
     */
    k: T | LottieKeyFrameModel.IJson[];
  }

  export interface IStaticAnimatedPropertyJson<T> extends IBaseJson<T> {
    a?: 0;
    k: T;
  }

  export interface IKeyframeAnimatedPropertyJson extends IBaseJson<never> {
    a: 1;
    k: LottieKeyFrameModel.IJson[];
  }
}
/* v8 ignore stop */
